module.exports = __webpack_public_path__ + "static/media/wifiqube-2.1c38fc18.jpg";